import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ModelesPlatsService} from '../../core/services/conditionnements/modeles-plats.service';
import ModeleConditionnementPlatDTO from '../../core/dtos/conditionnement/modele-conditionnement-plat-dto';
import {UtilsService} from '../../core/utils/utils.service';
import {Auth2Service} from '../../core/services/security/auth2.service';
import {RoutemapService} from '../../core/services/routemap.service';
import {FS_ROUTES, HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../core/constants';
import {DialogMsgSupplier, Paragraphe} from '../../core/suppliers/dialog-msg-supplier';
import {GenericManageDialogService} from '../../core/services/generics/generic-manage-dialog.service';
import {Subscription} from 'rxjs';
import {OverlayPanel} from "primeng/overlaypanel";
import {SiteDTO} from "../../core/dtos/site-dto";
import {ResponseWrapper} from "../../core/suppliers/wrappers/response-wrapper";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../core/services/technique/toast.service";
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'yo-modeles-plats',
  templateUrl: './modeles-plats.component.html',
  styleUrls: ['./modeles-plats.component.scss']
})
export class ModelesPlatsComponent implements OnInit, OnDestroy {

  modelesPlatsList: ModeleConditionnementPlatDTO[] = [];

  subModelePlatSaved: Subscription;

  hasIDistri = false;

  exportOptionList: any[] = [];
  selectExportOption: any;

  modeleIdToDuplicate: number;

  duplicationSiteSelected: SiteDTO;

  /**
   * La p-overlayPanel pour la duplication du modèle
   */
  @ViewChild('opDuplication') opDuplication: OverlayPanel;

  pathFile: string = HELP_FOLDERS.CONDITIONNEMENT + '/conditionnement-modeles-plats';

  allMode: string;
  checkBoxesMode: string;
  selectedRows: number[] = [];

  constructor(public utils: UtilsService,
              public auth2Svc: Auth2Service,
              private routeMapSvc: RoutemapService,
              private modelsPlatsSvc: ModelesPlatsService,
              private genericManageDialogService: GenericManageDialogService,
              private toastSvc: ToastService) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'always';
  }

  ngOnInit(): void {
    this.initModelesPlats();
    this.initHasGestionIDistri();
    this.initModelePlatSavedSubscription();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subModelePlatSaved);
  }

  initModelesPlats = (): void => {
    this.modelsPlatsSvc.getAllModelesConditionnementsPlats()
      .subscribe(response => {
        this.modelesPlatsList = response.resultList;
      });
  };

  initHasGestionIDistri = (): void => {
    this.auth2Svc.hasGestionIDistri$.subscribe(response => this.hasIDistri = response);
  };

  initModelePlatSavedSubscription = (): void => {
    this.subModelePlatSaved = this.modelsPlatsSvc.mcpSaved$
      .subscribe(response => {
        if (!response.isUpdate) {
          this.modelesPlatsList.push(response.mpc);
        } else {
          const idx = this.modelesPlatsList.findIndex(m => m.id === response.mpc.id);
          if (idx > -1) {
            this.modelesPlatsList[idx] = response.mpc;
          }
        }
      });
  };

  openModelePlat = (modelPlat: ModeleConditionnementPlatDTO): void => {
    this.genericManageDialogService.openEdit(modelPlat, FS_ROUTES.GESTION_CONDITIONNEMENTS_MODELE_PLAT);
  };

  calculateSiteValue = (modelPlat: ModeleConditionnementPlatDTO): string => {
    return modelPlat?.site?.libelle
  };

  /**
   * ouverture p-overlayPanel pour la duplication du modèle
   * @param $event
   * @param rowData
   */
  openPanelDuplication = ($event, rowData: ModeleConditionnementPlatDTO) => {
    if (this.auth2Svc.utilisateur.siteListLocaux.length >= 1) {
      this.duplicationSiteSelected = this.auth2Svc.utilisateur.siteListLocaux[0];
    } else {
      this.duplicationSiteSelected = this.auth2Svc.utilisateur.sitePrincipal;
    }
    this.modeleIdToDuplicate = rowData.id;
    this.opDuplication.toggle($event);
  };

  delete = async (): Promise<void> => {
    const response = await confirm(this.selectedRows.length > 1 ? `Confirmez-vous la suppression des éléments sélectionnés ?` : `Confirmez-vous la suppression de l'élément sélectionné ?`, `Suppression`);
    if (response) {
      this.modelsPlatsSvc.delete(this.selectedRows)
        .subscribe(() => {
          this.modelesPlatsList = this.modelesPlatsList.filter(m => !this.selectedRows.includes(m.id));
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Suppression réalisée avec succès`);
        });
    }
  }

  public help = (): DialogMsgSupplier => {
    const dms = new DialogMsgSupplier();
    dms.title = `Les modèles de plat`;
    dms.logo = 'fa fa-question-circle  yoni-color';
    const p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [];

    dms.content = {
      intro: ``,
      paragraphes: []
    };

    return dms;
  };

  canModify = (modelePlat: ModeleConditionnementPlatDTO): boolean => modelePlat.site && this.auth2Svc.isSiteLocal(modelePlat.site.id) && this.hasIDistri;

  canCreateAndDelete = (): boolean => this.hasIDistri;


  duplicateModele = async (): Promise<void> => {
    await alert("N'oubliez pas d'intégrer le nouveau modèle de plat à vos modèles de PLC !", "");
    this.modelsPlatsSvc.duplicateModele(this.modeleIdToDuplicate, this.duplicationSiteSelected.id, false)
      .subscribe((response: ResponseWrapper<ModeleConditionnementPlatDTO>) => {
        const msg = `Modèle de plat dupliqué avec succès.`;
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, msg);
        this.modelsPlatsSvc.announceMcpSaved(response.one, false);
        this.opDuplication.hide();
      });
  };

}
